export default __webpack_public_path__ + "static/media/KOD0153-min.35e8215f.webp";